import React from "react";
import Amenity from "./Amenity";

const Amenities = ({ beds, bathrooms, capacity }) => {
  return (
    <div className="flex flex-wrap items-center justify-between mb-2 sm:gap-4 gap-1">
      <Amenity icon="/icons/double-bed.svg" text={`${beds} yatak`} />
      <Amenity icon="/icons/shower.svg" text={`${bathrooms} banyo`} />
      <Amenity icon="/icons/user.svg" text={`${capacity} Kişilik`} />
    </div>
  );
};

export default Amenities;
